var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSelected = function SvgStarSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.082 20.176c.332.244.732.176 1.24-.195l5.322-3.897 5.322 3.896q.748.56 1.23.196c.333-.244.411-.645.206-1.24l-2.08-6.25 5.361-3.858c.508-.361.684-.732.557-1.123-.127-.38-.488-.576-1.113-.576l-6.582.039-2.012-6.28C11.337.284 11.044 0 10.644 0c-.41 0-.693.283-.889.889L7.744 7.168l-6.582-.04c-.635 0-.996.196-1.123.577-.127.39.058.762.566 1.123l5.352 3.858-2.07 6.25c-.206.595-.128.996.195 1.24"
  })));
};
export default SvgStarSelected;